import $http from '$http'
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
export default {
    methods: {
        getList() {
            var obj = this.query;
            if (obj.createTimeStart != "" && obj.createTimeStart != undefined) {
                obj.createTimeStart = new Date(obj.createTimeStart).toLocaleDateString();
            }
            if (obj.createTimeEnd != "" && obj.createTimeEnd != undefined) {
                obj.createTimeEnd = new Date(obj.createTimeEnd).toLocaleDateString();
            }
            if (obj.ReportStartTime1 != "" && obj.ReportStartTime1 != undefined) {
                obj.ReportStartTime1 = new Date(obj.ReportStartTime1).toLocaleDateString();
            }
            if (obj.ReportStartTime2 != "" && obj.ReportStartTime2 != undefined) {
                obj.ReportStartTime2 = new Date(obj.ReportStartTime2).toLocaleDateString();
            }
            if (obj.ReportEndTime1 != "" && obj.ReportEndTime1 != undefined) {
                obj.ReportEndTime1 = new Date(obj.ReportEndTime1).toLocaleDateString();
            }
            if (obj.ReportEndTime2 != "" && obj.ReportEndTime2 != undefined) {
                obj.ReportEndTime2 = new Date(obj.ReportEndTime2).toLocaleDateString();
            }
            var props = {};
            for (var p in obj) {
                if (obj[p] != "") {
                    props[p] = obj[p];
                    Object.assign({}, props)
                }
            }
            this.lists = [];
            this.loading = true; //拼命加载中显示
            var Params = Object.assign({}, { Sid: this.sysSid, Session: this.sysSession, pageIndex: this.pageIndex, pageSize: this.pageSize }, props);
            $http.get("api/School/ZqwPlatform_GetReportList", Params).then(res => {
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    this.totalSize = Cnt;
                    this.loading = false; //拼命加载中显示ss
                    this.lists = Data;
                    for (var i = 0; i < this.lists.length; i++) {
                        // this.lists[i].CreateTime = util.time2str(new Date(this.lists[i].CreateTime), "short");
                        // this.lists[i].ReportStartTime = util.time2str(new Date(this.lists[i].ReportStartTime), "short");
                        // this.lists[i].ReportEndTime = util.time2str(new Date(this.lists[i].ReportEndTime), "short");
                    }
                })
            })
        },
        DeleteItem(item) {
            $http.post("api/School/ZqwPlatform_DelIntentionSchool", item).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "删除成功",
                        type: "success"
                    });
                    this.getList();
                })
            })
        },
        getFollowList(options) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: options.pageIndex || 1,
                pageSize: options.pageSize || 10,
                Customer_Id: options.id
            };
            $http.get('api/Follow/GetFollowList', Params).then(res => {
                let { Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    this.followUpTotalSize = Cnt;
                    this.followUpList = Data;
                });
            });
        },
        addFollowUpItem(data) {
            data.Customer_Id = this.currentId;
            $http.post('api/Follow/AddFollow', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.getFollowList({ id: this.currentId });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        //获取跟进内容详情
        getFollowUpItem(id) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: id
            };
            $http.get('api/Follow/GetFollowById', Params).then(res => {
                let { Data } = res.data;
                util.doResult(this, res, () => {
                    this.followItem = Data;
                });
            });
        },
        //更新跟进内容详情
        updateFollowUpItem(data) {
            $http.post('api/Follow/UpdateFollow', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.getFollowList({ id: this.currentId });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        //删除跟进内容
        delFollowUpItem(id) {
            $http.post('api/Follow/DelFollow', { Id: id }).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.getFollowList({ id: this.currentId });
                    this.$refs.follow.closeEditBox();
                });
            });
        },
        officalSumit(Params) {
            $http.post("api/School/ZqwPlatform_PassReportSchool", Params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: "成功",
                        message: "提交转正成功",
                        type: 'success'
                    });
                    this.getList();
                    this.dialogClose();
                })
            })
        },
        /*获得单条数据 --点击转正*/
        GetSchoolModel(Id) {
            var Params = { Sid: this.sysSid, Session: this.sysSession, Id: Id };
            $http.get("api/School/ZqwPlatform_GetSchoolModel", Params).then(res => {
                util.doResult(this, res, () => {})
                let { Data } = res.data;
                // this.form.Id=Data.SchoolId;
                // this.form.hnc_drawing=Data.SchoolPics;
                // this.form.hndbond_drawing=Data.LicencePics;
                // this.form.hnd_CooperationPics=Data.CooperationPics;
                // this.form.hnd_EquipPics=Data.EquipPics;
                let a = Data.SchoolPics.split(",");
                for (var i = 0; i < a.length; i++) {
                    if (a[i] == "") {
                        a.splice(i, 1)
                    } else {
                        var obj = { Name: "", Url: a[i] };
                        this.SchoolPic.push(obj)
                    }
                }
                var b = Data.LicencePics.split(",");
                for (var i = 0; i < b.length; i++) {
                    if (b[i] == "") {
                        b.splice(i, 1)
                    } else {
                        var obj = { Name: "", Url: b[i] };
                        this.PermitPic.push(obj)
                    }
                }
                var c = Data.CooperationPics.split(",");
                for (var i = 0; i < c.length; i++) {
                    if (c[i] == "") {
                        c.splice(i, 1)
                    } else {
                        var obj = { Name: "", Url: c[i] };
                        this.contractPic.push(obj)
                    }
                }
                var d = Data.EquipPics.split(",");
                for (var i = 0; i < d.length; i++) {
                    if (d[i] == "") {
                        d.splice(i, 1)
                    } else {
                        var obj = { Name: "", Url: d[i] };
                        this.equipmentPic.push(obj)
                    }
                }
                this.form.Tel = Data.Tel;
                this.form.Email = Data.Email;
                this.form.QQ = Data.QQ;
                this.form.Weixin = Data.Weixin;
                this.form.PrincipalName = Data.PrincipalName;
                this.SchoolStatus = Data.SchoolStatusName;
            })
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/school/reportSchool/services.js